import { Matrix4, Vector3 } from "three";
import SceneObjectData from "./SceneObjectData";
import SceneObjectTypeEnum from "./SceneObjectTypeEnum";
import { quaternionFromJson, quaternionToJson, vector3FromJson, vector3ToJson } from "../../services/bimVisualizerApi/primitivesSerialization";
import Constants from "../../constants";
import { mmFromSceneUnits, sceneUnitsFromMm } from "../../utils/scaler";
import { applyOnlyRotation } from "../../utils/transformUtils";
import { UUID } from "../../utils/typeDefinitions";
import textAnnotationDataSchema from "../../services/bimVisualizerApi/schema/document/sceneObject/textAnnotationDataSchema";

class TextAnnotationData extends SceneObjectData {
    position: Vector3; 
    offset: Vector3;
    text: string;
    fontSize: number;
    textNormal: Vector3;
    textUp: Vector3;

    constructor(    position: Vector3, 
                    offset: Vector3 = new Vector3(0, 0, 0),
                    text: string = "",
                    fontSize: number = 0.06,
                    textNormal: Vector3 = new Vector3(0, 0, 1),
                    textUp: Vector3 = new Vector3(0, 1, 0),
                    uuid?: UUID,
                    parentId?: UUID) {
        super(SceneObjectTypeEnum.TextAnnotation, uuid, parentId);
        this.position = position;
        this.offset = offset;
        this.text = text;
        this.fontSize = fontSize
        this.textNormal = textNormal;
        this.textUp = textUp;
    }

    clone() : this {
        const clone = new TextAnnotationData( this.position.clone(),  
                                        this.offset.clone(), 
                                        this.text, this.fontSize, this.textNormal.clone(), this.textUp.clone(),
                                        this.uuid, this.parentId) as this;

        this.copyBaseData(clone);
        return clone;
    }

    

    applyMatrix4(matrix: Matrix4): void {
        this.position.applyMatrix4(matrix);
        applyOnlyRotation(this.offset, matrix);
        applyOnlyRotation(this.textNormal, matrix);
        applyOnlyRotation(this.textUp, matrix);
    }

    toJson(): any {
        return {
            ...super.toJson(),
            position: vector3ToJson(this.position, Constants.IO_LOCATION_PRECISION, mmFromSceneUnits),
            offset: vector3ToJson(this.offset, Constants.IO_LOCATION_PRECISION, mmFromSceneUnits),
            text: this.text,
            fontSize: mmFromSceneUnits(this.fontSize),
            textNormal: vector3ToJson(this.textNormal, Constants.IO_DIRECTION_PRECISION),
            textUp: vector3ToJson(this.textUp, Constants.IO_DIRECTION_PRECISION)
        };
    }

    static fromJson(json: any): TextAnnotationData {

        const parsedData = textAnnotationDataSchema.parse(json);

        return new TextAnnotationData(
            vector3FromJson(parsedData.position, sceneUnitsFromMm),
            vector3FromJson(parsedData.offset, sceneUnitsFromMm),
            parsedData.text,
            sceneUnitsFromMm(parsedData.fontSize),
            vector3FromJson(parsedData.textNormal),
            vector3FromJson(parsedData.textUp),
            parsedData.uuid,
            parsedData.parentId ?? undefined
        );
    }

}

export default TextAnnotationData;